export default __webpack_public_path__ + "a906f2ee36edda6b76ca5571422ad19e.png";